import React, { createContext, useContext, useEffect, useState } from "react";
import { api, authApi } from "@/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

const TOKEN_KEY = "ping_admin_token";

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null = checking, false = unauthenticated, object = authed
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setAdmin(false);
      setChecked(true);
      return;
    }
    authApi
      .get("/auth/me")
      .then(({ data }) => setAdmin(data))
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        setAdmin(false);
      })
      .finally(() => setChecked(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setAdmin(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setAdmin(false);
  };

  /** Called from AdminAccount after a successful credential update so the
   *  in-memory admin object + token stay in sync with the DB. */
  const setSession = (user, token) => {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    setAdmin(user);
  };

  return (
    <AuthContext.Provider value={{ admin, checked, login, logout, setSession }}>
      {children}
    </AuthContext.Provider>
  );
};
